export default {"src":"/_next/static/media/like-icon.0a9a284d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};